import { render, staticRenderFns } from "./fragment-server-error.vue?vue&type=template&id=36044d8c&scoped=true&"
import script from "./fragment-server-error.vue?vue&type=script&lang=js&"
export * from "./fragment-server-error.vue?vue&type=script&lang=js&"
import style0 from "./fragment-server-error.vue?vue&type=style&index=0&id=36044d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36044d8c",
  null
  
)

export default component.exports